/**
 * 用户接口
 */
import request, { MethodEnum } from '@/utils/fetch';
import { IAvatar } from './common';
import { PERMISSION_APIS } from './permission';
import { PromiseState } from '@/constants';

/** 签到接口Response */
interface SignApiResponse {
  days: number;
  mdays: number;
  lasted: number;
  signed: boolean;
  success: boolean; 
  increased: number;
}

export enum ACCOUNT_ROLE {
  USER = 'USER', // 普通用户
  ADMIN = 'ADMIN', // 管理员
  FORUM_ADMIN = 'FORUM_ADMIN' // 版主
}

export enum USER_APIS {
  USERS_INFO_LIST = '/users/login-info',
  LOGIN_OUT = '/auth/logout',
}

/** interfaces */
export interface IUserLoginInfo {
  uuid: string;
  name: string;
  messages: number;
  id: number;
  avatar: IAvatar;
  role: ACCOUNT_ROLE;
  status?: string;
}

export interface IUserPermission {
  status: PromiseState;
  code?: number;
  message?: string;
}

export const getUserLoginInfo = () => {
  const url = USER_APIS.USERS_INFO_LIST;
  return request({ url, params: {t: new Date().valueOf()} }).then((data: any) => {
    return data.item;
  }).catch((e)=>{
    return Promise.reject(e);
  });
};

export const loginOut = () => {
  const url = USER_APIS.LOGIN_OUT;
  return request({ url }).then((data: any) => {
    return data;
  }).catch((e)=>{
    return Promise.reject(e);
  });
}

export const getUserPermission = () => {
  const url = PERMISSION_APIS.PERMISSION_CHECK;
  return request({
    url,
    method: MethodEnum.POST,
  }).then((data: {item?: string}) => {
    return data.item;
  }).catch((e)=>{
    return Promise.reject(e);
  });
};

/** 用户签到 */
export const userSign = () => {
  return request({
    url: '/home/paulsigns/sign',
    method: MethodEnum.POST,
  }).then((data: {item: SignApiResponse}) => {
    return data.item;
  }).catch((e)=>{
    return Promise.reject(e);
  });
};
